import { Component, OnInit } from '@angular/core';
import { AppContextService } from '../../../shared/services/app-context.service';

@Component({
  selector: 'townip-mfa-setup-complete',
  templateUrl: './mfa-setup-complete.component.html',
  styleUrl: './mfa-setup-complete.component.scss'
})
export class MfaSetupCompleteComponent implements OnInit {

  constructor(public appContext: AppContextService) {
  }

  public ngOnInit(): void {
  }

}
